import gql from 'graphql-tag'

export const UPDATE_SCHEDULER = gql`
  mutation update_scheduler($input: SchedulerInput) {
    update_scheduler(input: $input)
      @rest(type: "Scheduler", path: "/update-scheduler", bodyKey: "input", method: "POST") {
      id
      name
      status
      definition
      next_run_at
      last_updated_by
      entity_ids
      entity_type_ids
      created_at
      updated_at
      result
    }
  }
`
